import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-ajout-integration',
  templateUrl: './ajout-integration.component.html',
  styleUrls: ['./ajout-integration.component.scss']
})
export class AjoutIntegrationComponent implements OnInit {

  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  /** Type d’intégration sélectionné (radios du popup). */
  selectedIntegration: 'wordpress' | 'prestashop' | 'webapp' = 'wordpress';

  constructor(private modalService: NgbModal) {}
  private modalRef!: NgbModalRef;
  ngOnInit(): void {
  }
  openModal() {
    const options: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      keyboard: true,
      size: 'lg',
    };
    this.modalRef = this.modalService.open(this.modalTemplate, options);
  }

}
